<div class="m-2 lg:m-6">
  <ng-container *ngIf="overview$ | async as overview">
    <div class="flex flex-col mb-3">
      <div class="flex flex-row w-full justify-between">
        <div
          class="font-bold leading-8 text-3xl"
          *ngIf="overview.hasTruck && overview.totalPaidDeposit < overview.totalAssetDeposit; else genericHeader"
        >
          Please Note!
        </div>
        <ng-template #genericHeader>
          <div class="font-bold text-xl">Settled Payments</div>
        </ng-template>
        <button mat-raised-button (click)="getFuelTransactions()">Export Fuel Transactions</button>
      </div>
      <div
        class="text-lg"
        *ngIf="overview.hasTruck && overview.totalPaidDeposit < overview.totalAssetDeposit; else genericMessage"
      >
        <div><span class="text-3xl">🚚</span> Thank you for participating in the truck leasing program!</div>
        While you have an outstanding deposit balance (<span class="font-bold">{{
          overview.totalPaidDeposit | currencyInPennies
        }}</span>
        deposited of <span class="font-bold">{{ overview.totalAssetDeposit | currencyInPennies }}</span
        >), your loads will be settled once a week on <span class="font-bold text-xl">Thursday</span>. Once you have
        fulfilled your deposit obligation, your loads will start to settle
        <span class="font-bold text-xl">every day</span>!
      </div>
      <ng-template #genericMessage>
        <span>Every day we pay out all loads approved by you and the customer the prior day.</span>
      </ng-template>
      <div class="mt-3 flex-1 max-h-[400px]">
        <lohi-driver-kpi-total-revenue-chart></lohi-driver-kpi-total-revenue-chart>
      </div>
    </div>
    <div class="grid lg:grid-cols-3 gap-3 mb-3">
      <div class="flex flex-row justify-between gap-2" *ngIf="metricCards$ | async as metricCards">
        <lohi-driver-kpi-statistic
          title="Total Revenue"
          [priorValue]="metricCards.totalRevenue.previousValueCents"
          [currentValue]="metricCards.totalRevenue.currentValueCents"
          [duration]="KPIDuration.oneMonth"
        ></lohi-driver-kpi-statistic>
      </div>
      <div class="flex flex-row justify-between gap-2" *ngIf="metricCards$ | async as metricCards">
        <lohi-driver-kpi-statistic
          title="Average Revenue Per Week"
          [priorValue]="metricCards.averageRevenuePerWeek.previousValueCents"
          [currentValue]="metricCards.averageRevenuePerWeek.currentValueCents"
          [duration]="KPIDuration.oneMonth"
        ></lohi-driver-kpi-statistic>
      </div>
      <div class="flex flex-row justify-between gap-2" *ngIf="metricCards$ | async as metricCards">
        <lohi-driver-kpi-statistic
          title="Average Turn Rate Per Shift"
          [cents]="false"
          [priorValue]="metricCards.averageTurnRatePerShift.previousValue"
          [currentValue]="metricCards.averageTurnRatePerShift.currentValue"
          [duration]="KPIDuration.oneWeek"
          numberFormat="1.0-1"
        ></lohi-driver-kpi-statistic>
      </div>

      <div class="flex flex-row">
        <img src="assets/images/wallet.svg" class="mr-2 w-8 h-8" alt="payable to you" />
        <div class="flex flex-col text-lg text-gray-900 self-center">
          <span>Payable To You (Past 7d):</span>
          <div class="flex flex-col justify-center">
            <div class="font-bold">
              {{ overview.totalPayableOver7Days | currencyInPennies }}
            </div>
            <div class="mt-2" *ngIf="overview.totalPayableOver7Days && overview.totalTrucksOver7Days">
              That's {{ overview.totalPayableOver7Days / overview.totalTrucksOver7Days | currencyInPennies }} Per Truck
            </div>
          </div>
        </div>
      </div>

      <ng-template #internalDepositTooltip>
        <div class="font-bold">🔐 Only visible to internal folks 🔐</div>
        <div *ngIf="overview.escrowDetails.escrowTotalOverride; else regularEscrow" class="leading-10">
          🚨 This company has an override escrow of {{ overview.escrowDetails.escrowTotalOverride | currencyInPennies }}
          which is overriding normal settings
        </div>
        <ng-template #regularEscrow>
          <div
            class="flex justify-between"
            *ngFor="
              let item of overview.escrowDetails.lineItems;
              trackBy: overview.escrowDetails.lineItems | trackByKey2: 'name'
            "
          >
            <div>{{ item.name }} ({{ item.count }})</div>
            <div>{{ item.totalInPennies | currencyInPennies }}</div>
          </div>
          <div *ngIf="overview.escrowDetails.maxEscrowInPennies">
            This company has a max escrow set of {{ overview.escrowDetails.maxEscrowInPennies | currencyInPennies }}
          </div>
        </ng-template>
      </ng-template>
      <div class="flex flex-row">
        <img src="assets/images/pig.svg" class="mr-2 w-8 h-8" alt="piggy bank" />
        <div class="flex flex-col text-lg text-gray-900 self-center">
          <span>Deposit - Earning 5% Interest:</span>
          <div class="flex flex-row justify-center font-bold items-center">
            {{ overview.totalPaidDeposit | currencyInPennies }} of
            {{ overview.totalAssetDeposit | currencyInPennies }} Total Deposit
            <mat-icon class="text-gray-500" *lohiInternal content-type="template" [tooltip]="internalDepositTooltip"
              >info
            </mat-icon>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <div class="flex flex-col text-lg text-gray-900 self-center">
          <a [routerLink]="['/kpis/revenue-performance']">
            <span class="font-extrabold text-red-500">How to Earn More Money</span>
          </a>
        </div>
      </div>
    </div>
    <div class="lg:grid grid-cols-1 lg:grid-cols-7 bg-white px-3 py-2 font-bold hidden border-b border-gray-400">
      <div class="text-left pl-3">Date</div>
      <div class="lg:block">Loads</div>
      <div>Status</div>
      <div></div>
      <div class="col-span-1"></div>
      <div class="text-right pr-6 col-span-1">Total Payable to You</div>
      <!-- TEMP DISABLED: payment issue reporting
      <div>Payment Issue</div>
      -->
    </div>

    <a
      [routerLink]="['/settlement', 'details', summary.id]"
      *ngFor="let summary of summaries$ | async; trackBy: 'id' | trackByKey"
    >
      <div class="bg-white border-b border-gray-400 px-3 py-2 hover:bg-gray-300">
        <div class="lg:grid grid-cols-7 font-bold w-full text-base hidden">
          <div class="text-left flex pl-3">
            <span *ngIf="summary.paidAt" matTooltip="Payment Sent at {{ summary.paidAt | standardDate }}">💰</span>
            {{ summary.month }}/{{ summary.day }}/{{ summary.year }}
          </div>
          <div>{{ summary.loadCount }}</div>
          <div>{{ summary.paidAt ? 'Paid' : 'Pending' }}</div>
          <div class="col-span-1"></div>
          <div class="col-span-1"></div>
          <div class="flex flex-row justify-end">
            <div class="text-right pr-3">{{ summary.payableInPennies | currencyInPennies }}</div>
          </div>
          <div class="col-span-1 flex items-center justify-between">
            <!-- TEMP DISABLED: payment issue reporting
            <div>
              <ng-container *ngIf="!summary.paymentIssue; else hasIssue">
                <button mat-stroked-button color="primary" (click)="openReportIssue($event, summary)">
                  Report payment issue
                </button>
              </ng-container>
              <ng-template #hasIssue>
                <button mat-stroked-button color="accent" (click)="openViewIssue($event, summary)">
                  {{ summary.paymentIssue?.respondedAt ? 'Resolved' : 'Submitted' }}
                </button>
              </ng-template>
            </div>
            -->
            <div class="flex items-center justify-end ml-auto">
              <span class="material-icons"> navigate_next </span>
            </div>
          </div>
        </div>
        <div class="flex justify-between lg:hidden w-full">
          <div class="text-left flex">
            <div>
              {{ summary.date | standardDateOnly }}
            </div>
          </div>
          <div class="flex flex-row justify-end">
            <div class="text-right pr-3">{{ summary.payableInPennies | currencyInPennies }}</div>
            <!-- TEMP DISABLED: payment issue reporting
            <div class="ml-2">
              <ng-container *ngIf="!summary.paymentIssue; else hasIssueMobile">
                <button mat-stroked-button color="primary" (click)="openReportIssue($event, summary)">
                  Report issue
                </button>
              </ng-container>
              <ng-template #hasIssueMobile>
                <button mat-stroked-button color="accent" (click)="openViewIssue($event, summary)">
                  {{ summary.paymentIssue?.respondedAt ? 'Resolved' : 'Submitted' }}
                </button>
              </ng-template>
            </div>
            -->
            <div class="ml-2">
              <div class="flex items-center justify-end w-full">
                <span class="material-icons"> navigate_next </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </ng-container>
</div>
